import { Component } from '@angular/core';

import { getNavItems } from './_nav';
import { TokenStorageService } from '../../token-storage.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './default-layout.component.html',
  styleUrls: ['./default-layout.component.scss'],
})
export class DefaultLayoutComponent {
  public navItems;
  roles: string[];

  constructor(
    private tokenStorageService: TokenStorageService
  ) {
    this.roles = this.tokenStorageService.getRole();
    this.navItems = getNavItems(this.roles);
  }
}
